import { Link } from "react-router-dom";
import Login from '../login';
import Alert from '../Usersmanagement/Element/alert';
import { useState, useEffect } from "react";

function Header({ userId, logout }) {
    const [alerts, setAlerts] = useState([]);
    const [user, setUser] = useState(null);

    useEffect(() => {
        console.log("Header useEffect - userId:", userId);
        if (userId) {
            fetchUserData(userId);
        }
    }, [userId]);

    const fetchUserData = async (id) => {
        try {
            const token = localStorage.getItem('token');
            console.log("Fetching user with ID:", id, "Token:", token ? "exists" : "missing");
            
            const res = await fetch(`/api/get_user/${id}`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            console.log("API Response status:", res.status);
            const data = await res.json();
            // console.log("API Response data:", data);
            
            if (res.ok) {
                setUser(data);
                console.log("User set:", data);
            } else {
                console.error("Failed to fetch user:", data.message || data);
                setUser(null);
            }
        } catch (error) {
            console.error("Error fetching user:", error.message);
            setUser(null);
        }
    };

    const addAlert = (message, type) => {
        const id = Date.now() + Math.random();
        const newAlert = { id, message, type };
        setAlerts(prev => [...prev, newAlert]);

        // Auto remove after 3 seconds
        setTimeout(() => {
            setAlerts(prev => prev.filter(alert => alert.id !== id));
        }, 3000);
    };

    const removeAlert = (id) => {
        setAlerts(prev => prev.filter(alert => alert.id !== id));
    };
    const toggleSidebar = () => {
        document.body.classList.toggle("toggle-sidebar")
    }
    return (
        // Header
        <>
            {alerts.map((alert, index) => (
                <Alert
                    key={alert.id}
                    show={true}
                    message={alert.message}
                    type={alert.type}
                    onClose={() => removeAlert(alert.id)}
                    style={{ top: `${10 + index * 70}px` }}
                />
            ))}

            <header id="header" className="header fixed-top d-flex align-items-center">
                <div className="d-flex align-items-center justify-content-between">
                    <i className="bi bi-list toggle-sidebar-btn me-3" onClick={toggleSidebar} style={{ cursor: "pointer" }}></i>
                    <a className="logo d-flex align-items-center" >
                        <span className="d-none d-lg-block " style={{ fontSize: "27px", fontWeight: 700, color: "#0A192F", fontFamily: "'Poppins', sans-serif" }} >Magsayo Admin</span>
                    </a>
                </div>

                <div className="search-bar">
                    <form className="search-form d-flex align-items-center" method="POST" action="#">
                        <input type="text" name="query" placeholder="Search" title="Enter search keyword" />
                        <button type="submit" title="Search"><i className="bi bi-search"></i></button>
                    </form>
                </div>

                <nav className="header-nav ms-auto">
                    <ul className="d-flex align-items-center">
                        <li className="nav-item dropdown">

                            <a className="nav-link nav-icon" href="#" data-bs-toggle="dropdown">
                                <i className="bi bi-bell"></i>
                                <span className="badge bg-primary badge-number">4</span>
                            </a>
                            {/* <!-- End Notification Icon --> */}

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow notifications">
                                <li className="dropdown-header">
                                    You have 4 new notifications
                                    <a href="#"><span className="badge rounded-pill bg-primary p-2 ms-2">View all</span></a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-exclamation-circle text-warning"></i>
                                    <div>
                                        <h4>Lorem Ipsum</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>30 min. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-x-circle text-danger"></i>
                                    <div>
                                        <h4>Atque rerum nesciunt</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>1 hr. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-check-circle text-success"></i>
                                    <div>
                                        <h4>Sit rerum fuga</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>2 hrs. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li className="notification-item">
                                    <i className="bi bi-info-circle text-primary"></i>
                                    <div>
                                        <h4>Dicta reprehenderit</h4>
                                        <p>Quae dolorem earum veritatis oditseno</p>
                                        <p>4 hrs. ago</p>
                                    </div>
                                </li>

                                <li>
                                    <hr className="dropdown-divider" />
                                </li>
                                <li className="dropdown-footer">
                                    <a href="#">Show all notifications</a>
                                </li>

                            </ul>
                            {/* <!-- End Notification Dropdown Items --> */}

                        </li>
                        
                        <li className="nav-item d-block d-lg-none">
                            <a className="nav-link nav-icon search-bar-toggle " href="#">
                                <i className="bi bi-search"></i>
                            </a>
                        </li>
                        <li className="nav-item dropdown pe-3">
                            <a className="nav-link nav-profile d-flex align-items-center pe-0" href="#" data-bs-toggle="dropdown">
                                <img src="assets/img/CEO.png" alt="Profile" className="rounded-circle" />
                                <span className="d-none d-md-block dropdown-toggle ps-2" style={{ fontFamily: "Montserrat" }}>
                                    {!userId ? 'Not Logged In' : user?.f_name ? `${user?.f_name}`.trim() : 'Loading...'}
                                </span>
                            </a>
                            {/* <!-- End Profile Iamge Icon --> */}

                            <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
                                <li className="dropdown-header">
                                    <h6 style={{ fontFamily: "'Montserrat', sans-serif" }}>
                                        {!userId ? 'Not Logged In' : user?.f_name ? `${user?.f_name} ${user?.l_name || ''}`.trim() : 'Loading...'}
                                    </h6>
                                    <span>{user?.role || 'N/A'}</span>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <a className="dropdown-item d-flex align-items-center" href="users-profile.html">
                                        <i className="bi bi-person"></i>
                                        <Link to={`/User_Profile/${userId}`}>My Profile</Link>
                                    </a>
                                </li>
                                <li>
                                    <hr className="dropdown-divider" />
                                </li>

                                <li>
                                    <button className="dropdown-item d-flex align-items-center" onClick={() => {
                                        const userName = user ? `${user?.f_name || ''} ${user?.l_name || ''}`.trim() : 'User';
                                        addAlert("Goodbye, " + userName + "!", "success");
                                        setTimeout(() => {
                                            localStorage.removeItem('token');
                                            logout();
                                        }, 1500);
                                    }}>
                                        <i className="bi bi-box-arrow-right"></i>
                                        <span>Sign Out</span>
                                    </button>
                                </li>

                            </ul>
                            {/* <!-- End Profile Dropdown Items --> */}
                        </li>
                        {/* <!-- End Profile Nav --> */}

                    </ul>
                </nav>

            </header>
            {/*  End Header */}
            {/* <!-- ======= Sidebar ======= --> */}
            <aside id="sidebar" className="sidebar">
                <ul className="sidebar-nav" id="sidebar-nav">
                    <li className="nav-item">
                        <Link className="nav-link collapsed" to="/" >
                            <i className="bi bi-grid"></i>
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    {/* end of dashboard */}
                    <li className="nav-item">
                        <a className="nav-link collapsed" data-bs-target="#components-nav" data-bs-toggle="collapse" href="#">
                            <i className="bi bi-person"></i><span>User Management</span><i className="bi bi-chevron-down ms-auto"></i>
                        </a>
                        <ul id="components-nav" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                            <li>
                                {/* <a href="#">
                                    <i className="bi bi-circle"></i><span>Users</span>
                                </a> */}
                                <Link to="/Users" >
                                    <i className="bi bi-circle"></i><span>Users</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/RoleandPermission">
                                    <i className="bi bi-circle"></i><span>Roles & Permissions</span>
                                </Link>
                            </li>
                             <li>
                                <Link to="/Accounts">
                                    <i className="bi bi-circle"></i><span>Accounts</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/Access_History">
                                    <i className="bi bi-circle"></i><span>Access History</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    {/* <!-- End user Nav --> */}

                    <li className="nav-item">
                        <a className="nav-link collapsed" data-bs-target="#components-nav3" data-bs-toggle="collapse" href="#">
                            <i className="bi bi-menu-button-wide"></i><span>Branch Management</span><i className="bi bi-chevron-down ms-auto"></i>
                        </a>
                        <ul id="components-nav3" className="nav-content collapse " data-bs-parent="#sidebar-nav">
                            <li>
                                <Link to="/Media_Branch" >
                                    <i className="bi bi-circle"></i><span>Media</span>
                                </Link>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="bi bi-circle"></i><span>Marketing</span>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="bi bi-circle"></i><span>Software Industry</span>
                                </a>
                            </li>
                            <li>
                                <a href="#">
                                    <i className="bi bi-circle"></i><span>Branding</span>
                                </a>
                            </li>
                        </ul>
                    </li>
                    {/* <!-- End Components Nav --> */}

                    <li className="nav-heading">Security</li>

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="#">
                            <i className="bi bi-card-list"></i>
                            <span>Acivity Logs</span>
                        </a>
                    </li>
                    {/* <!-- End Profile Page Nav --> */}

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="#">
                            <i className="bi bi-question-circle"></i>
                            <span>Failed Login Attemps</span>
                        </a>
                    </li>
                    {/* <!-- End F.A.Q Page Nav --> */}

                    <li className="nav-item">
                        <a className="nav-link collapsed" href="#">
                            <i className="bi bi-gear"></i>
                            <span>System Updates</span>
                        </a>
                    </li>
                    {/* <!-- End Contact Page Nav --> */}
                </ul>
            </aside>
            {/* <!-- End Sidebar--> */}
        </>
    )
}

export default Header